/* unplugin-vue-components disabled */import script from "./answer.vue?vue&type=script&setup=true&lang=js"
export * from "./answer.vue?vue&type=script&setup=true&lang=js"

import "./answer.vue?vue&type=style&index=0&id=fdc9d93c&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdc9d93c"]])

export default __exports__